import React, { useEffect, useState } from 'react';
import { FaPaintBrush, FaHammer, FaBuilding, FaHardHat, FaToolbox, FaRulerCombined } from 'react-icons/fa';

const services = [
  { icon: <FaPaintBrush className="text-blue-500" />, text: 'pintura', minBudget: 300, maxBudget: 800 },
  { icon: <FaHammer className="text-yellow-500" />, text: 'renovación', minBudget: 1000, maxBudget: 5000 },
  { icon: <FaBuilding className="text-green-500" />, text: 'arquitectura', minBudget: 2000, maxBudget: 10000 },
  { icon: <FaHardHat className="text-orange-500" />, text: 'ingeniería', minBudget: 1500, maxBudget: 7000 },
  { icon: <FaToolbox className="text-brown-500" />, text: 'carpintería', minBudget: 500, maxBudget: 2000 },
  { icon: <FaRulerCombined className="text-purple-500" />, text: 'diseño de interiores', minBudget: 800, maxBudget: 3000 },
];

const clients = [
  'María',
  'Carlos',
  'John',
  'Javier',
  'Ana',
  'Fernand',
  'Laura',
  'Sophie',
  'Marta',
  'José',
];

const actionPhrases = [
  'solicitó un servicio de',
  'necesita un servicio de',
];

const getRandomService = () => services[Math.floor(Math.random() * services.length)];
const getRandomClient = () => clients[Math.floor(Math.random() * clients.length)];
const getRandomPhrase = () => actionPhrases[Math.floor(Math.random() * actionPhrases.length)];
const getRandomBudget = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const ServiceUsageSimulator = () => {
  const [currentService, setCurrentService] = useState({ client: '', service: { icon: null, text: '', minBudget: 0, maxBudget: 0 }, phrase: '', budget: 0 });

  useEffect(() => {
    const interval = setInterval(() => {
      const service = getRandomService();
      const budget = getRandomBudget(service.minBudget, service.maxBudget);
      setCurrentService({
        client: getRandomClient(),
        service,
        phrase: getRandomPhrase(),
        budget,
      });
    }, 3000); // Cambia cada 3 segundos

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white py-3 px-6 flex items-center justify-center shadow-lg transform translate-y-0 transition-transform duration-500">
      <div className="flex items-center animate-marquee">
        {currentService.service.icon}
        <p className="ml-3 text-lg sm:text-xl font-semibold animate-pulse">
          <strong>{currentService.client}</strong> {currentService.phrase} <span className="font-bold">{currentService.service.text}</span> con un presupuesto de <span className="font-bold">${currentService.budget}</span>
        </p>
      </div>
    </div>
  );
};

export default ServiceUsageSimulator;
